import { useScrollbarWidthOffset } from '../hooks/useScrollbarWidthOffset';

const ScrollbarWidthOffset = ({ container }: { container?: HTMLElement }) => {
  useScrollbarWidthOffset(container);
  return null;
};

export default ScrollbarWidthOffset;
